export default __webpack_public_path__ + "static/media/action.02081ca5.png";